import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getData } from '../Services/api';

const ViewCms = () => {
    const { slug } = useParams();
    const [values, setValues] = useState({
        title: "",
        content: "",
    });

    const fetchCmsDetails = async () => {
        try {
            const res = await getData(`/cms/${slug}`);
            if (res.status) {
                setValues(res.data || {})
            }
        } catch (error) {
            console.log("error fetch cms details", error)
        }
    }

    useEffect(() => {
        fetchCmsDetails();
    }, [slug])
    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/cms/cms-list">CMS</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            CMS Details
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">CMS Details</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>CMS Details</h5>
                                </div>
                                <div className="card-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Title</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Text"
                                                        name='title'
                                                        value={values.title}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="form-label">Description</label>
                                                    <p className='border rounded p-2' dangerouslySetInnerHTML={{ __html: values.content }} />
                                                </div>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewCms